module.exports = __webpack_public_path__ + "static/img/er_wei_ma.7b6f71e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/pc/newInfo/er_wei_ma.jpg
// module id = GA02
// module chunks = 0